require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/fn/object/get-prototype-of.js
// module id = ../../../node_modules/core-js/library/fn/object/get-prototype-of.js
// module chunks = 0